<template>
  <div>
    <div class="row">
      <div class="col-2">
        <ProfileSidebarMenu
          personalData
          education
          professionalExp
          language
          subscriptions
        />
      </div>

      <div class="col-12 col-md-10">
        <div class="position-relative">
          <LoaderContent
            v-if="!graphql_loaded"
            :welcomeMessage="false"
            :alignSpinnerTop="true"
            loaderContentClass="rounded-xl"
          />
          <div v-else>
            <BoxPersonalData
              ref="box-personal-data"
              format="inline-form"
              id="box-personal-data"
              class="bg-white shadow p-4 p-md-5 rounded-xl"
            />

            <div class="py-4"></div>

            <BoxEducation
              ref="box-education"
              format="inline-form"
              id="box-education"
              class="bg-white shadow p-4 p-md-5 rounded-xl"
            />

            <div class="py-4"></div>

            <BoxProfessionalExp
              ref="box-professional-experience"
              format="inline-form"
              id="box-professional-experience"
              class="bg-white shadow p-4 p-md-5 rounded-xl"
            />

            <div class="py-4"></div>

            <BoxLanguage
              ref="box-language"
              format="inline-form"
              id="box-language"
              class="bg-white shadow p-4 p-md-5 rounded-xl"
            />

            <div class="py-4"></div>

            <BoxSubscriptions
              ref="box-subscription"
              format="inline-form"
              id="box-subscription"
              class="bg-white shadow p-4 p-md-5 rounded-xl"
            />

            <div class="py-4"></div>

            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-sm"
                v-if="removeAccountLink"
                @click="removeAccount"
              >
                Remover minha Conta
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoaderContent from "ninenine-white-label/src/components/Loader/LoaderContent.vue";
  import EllipsisLoader from "ninenine-white-label/src/components/Loader/EllipsisLoader.vue";
  import BoxPersonalData from "ninenine-white-label/src/components/PersonalData/BoxPersonalData.vue";
  import BoxEducation from "ninenine-white-label/src/components/Education/BoxEducation.vue";
  import BoxProfessionalExp from "ninenine-white-label/src/components/ProfessionalExp/BoxProfessionalExp.vue";
  import BoxLanguage from "ninenine-white-label/src/components/Language/BoxLanguage.vue";
  import BoxSubscriptions from "ninenine-white-label/src/components/Subscriptions/BoxSubscriptions.vue";
  import ProfileSidebarMenu from "@/components/ProfileSidebarMenu.vue";
  import ModalDiversityInputs from "@/components/ModalDiversityInputs.vue";

  import api from '@/data.json'

  export default {
    name: "RegisterProfile",

    data() {
      return {
        graphql_loaded: false,
        isSaving: false,
        removeAccountLink: null,
        api: api
      };
    },

    computed: {
      screenSizeKey(){
        return window.outerWidth < 780 ? 'mobile' : 'desktop'
      },
    },

    components: {
      LoaderContent,
      EllipsisLoader,
      BoxPersonalData,
      BoxEducation,
      BoxProfessionalExp,
      BoxLanguage,
      BoxSubscriptions,
      ProfileSidebarMenu,
      ModalDiversityInputs,
    },

    mounted() {
      setTimeout(() => this.removeAutoFillSelectize(), 500);
      this.getProfile();
    },

    methods: {
      removeAccount() {
        this.$swal({
          title: "Tem certeza que deseja remover sua conta?",
          text: "Você será direcionado para o site 99jobs.com para concluir a exclusão.",
          type: "info",
          showCancelButton: true,
          cancelButtonText: "Não",
          confirmButtonText: "Sim, tenho certeza",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.open(this.removeAccountLink, "_blank");
            this.$store.dispatch("user/signOut");
            if (this.$route.meta.requiresAuth) this.$router.push("/");
          }
        });
      },

      scroll() {
        window.scroll(0, 1);
      },

      getProfile() {
        let requestDomainReturn = "";

        if (this.$store.state.domains.countries.length == 0) {
          requestDomainReturn += `countries { id, name },`;
        }
        if (this.$store.state.domains.genders.length == 0) {
          requestDomainReturn += `genders { id, description },`;
        }
        if (this.$store.state.domains.maritalStatus.length == 0) {
          requestDomainReturn += `maritalStatus {id, description},`;
        }
        if (this.$store.state.domains.states.length == 0) {
          requestDomainReturn += `states { id, name, abbr },`;
        }
        if (this.$store.state.domains.disabilities.length == 0) {
          requestDomainReturn += `disabilities { id, name },`;
        }
        if (this.$store.state.domains.education_levels.length == 0) {
          requestDomainReturn += `educationLevels {id, description},`;
        }
        if (this.$store.state.domains.education_status.length == 0) {
          requestDomainReturn += `educationStatus {id, description},`;
        }
        if (this.$store.state.domains.companies.length == 0) {
          requestDomainReturn += `companies {id, name},`;
        }
        if (this.$store.state.domains.professional_experience_areas.length == 0) {
          requestDomainReturn += `professionalExperienceAreas {id, name},`;
        }
        if (
          this.$store.state.domains.professional_experience_levels.length == 0
        ) {
          requestDomainReturn += `professionalExperienceLevels {id, name}`;
        }
        if (this.$store.state.domains.languages.length == 0) {
          requestDomainReturn += `languages {id, name},`;
        }
        if (this.$store.state.domains.language_proficiencies.length == 0) {
          requestDomainReturn += `languageProficiencies {id, description},`;
        }

        requestDomainReturn += `genders { id, description },`;
        requestDomainReturn += `raceAndEthnicities { id, description },`;
        requestDomainReturn += `pronouns { id, description },`;
        requestDomainReturn += `personalIncomes { id, description },`;
        requestDomainReturn += `familyIncomes { id, description },`;
        requestDomainReturn += `sexualOrientations {id, description},`;
        requestDomainReturn += `disabilities { id, name },`;

        if (requestDomainReturn.length > 0) {
          requestDomainReturn = `domains {
            ${requestDomainReturn}
          },`;
        }

        this.$store
          .dispatch(
            "graphql_queries/query",
            `
          ${requestDomainReturn}
          user( id: "${this.$store.state.user.profile.id}" ){
            avatar,
            removeAccountLink,
            medicalReports {
              id,
              name,
              file
            },
            profile{
              firstname,
              lastname,
              socialName,
              email,
              nationality,
              cpf,
              passport,
              gender,
              maritalStatus,
              phone,
              birthday,
              whatDoYouLove,
              raceAndEthnicity,
              pronoun,
              sexualOrientation,
              personalIncome,
              familyIncome,
              descriptionHelpSelectionProcess,
              needHelpSelectionProcess,

              location {
                zipcode,
                street,
                number,
                complement,
                neighborhood,
                stateId,
                city
              },

              hasDisability,

              disabilities {
                disabilityId,
                name
              },

              educations {
                id,
                institutionName,
                level,
                courseName,
                startDate,
                endDate,
                stateId
              },

              professionalExperiences {
                id,
                role,
                responsabilities,
                company,
                startYear,
                endYear
              },

              languageProficiencies {
                id,
                language,
                proficiency
              },

            }
          },
        `
          )
          .then((results) => {
            this.graphql_loaded = true;
            this.removeAccountLink = results.user.removeAccountLink;
            setTimeout(() => this.$EventBus.$emit("editingPersonalData"), 100);
          });
      },
    },
  };
</script>